<template>
    <div class="main-box">
        <!-- <el-dialog v-if="dialogFormVisible" custom-class="box-dialog" :visible.sync="dialogFormVisible" append-to-body="true" width="75%" height="650px" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" title="学生档案"> -->
        <div class="info-box">
            <!-- <img :src="imageSrc" style="width:100px;height:100px;border-radius:10px;margin-right: 20px;"></img> -->
            <!-- <el-image :src="imageSrc" style="width:100px;height:100px;border-radius:10px;margin-right: 20px;" @error="avatarError"> -->
            <el-image :src="imageSrc" style="width: 100px; height: 100px; border-radius: 10px; margin-right: 20px" fit="contain">
                <div slot="error" class="image-slot">
                    <img style="width: 100%" :src="'./images/w-imgs/default_avatar.png'" alt="" />
                </div>
            </el-image>
            <div style="flex: 1">
                <div>
                    <span>{{ vo.name }}</span>
                </div>
                <div style="display: flex">
                    <div style="min-width: 150px">学号：{{ vo.studentId }}</div>
                    <div style="min-width: 200px">专业：{{ vo.majorSubcategory }}</div>
                    <div>班级：{{ vo.className }}</div>
                </div>
                <div style="display: flex">
                    <div style="min-width: 150px">学制：{{ filterEducationSystem(vo.educationSystem) }}</div>
                    <div>{{ filterStatus(vo.studentFileStatus) }}</div>
                </div>
            </div>
            <div>
                <!-- v-if="cardList.length===1" -->
                <template>
                    <el-button type="primary" @click="showCard">查看学籍卡</el-button>
                </template>
                <!-- <template v-if="cardList.length===2">
               <el-button type="primary" @click="showCard(1)">查看中级学籍卡</el-button>
               <el-button type="primary" @click="showCard(2)">查看高级学籍卡</el-button>
            </template> -->
            </div>
        </div>
        <el-tabs v-model="activeTabName" style="width: 100%" @tab-click="changeTab">
            <el-tab-pane label="基本信息" name="User" />
            <el-tab-pane label="分班记录" name="Record" />
            <!-- <el-tab-pane label="学费缴纳" name="Fee" /> -->
            <!-- <el-tab-pane label="家庭成员" name="Family" /> -->
            <el-tab-pane label="宿舍情况" name="Hostel" />
            <el-tab-pane label="考试成绩" name="Exam" />
            <el-tab-pane label="资助记录" name="Grant" />
            <el-tab-pane label="获奖情况" name="Award" />
            <el-tab-pane label="违规违纪" name="Violation" />
            <el-tab-pane label="请假记录" name="Leave" />
            <el-tab-pane label="毕业离校" name="Graduate" />
        </el-tabs>

        <div v-if="activeTabName === 'User'">
            <InfoView :vo="vo" :can-edit="canEdit"></InfoView>
        </div>
        <div v-if="activeTabName === 'Record'">
            <Record :vo="vo" :can-edit="canEdit"></Record>
        </div>
        <div v-else-if="activeTabName == 'Fee'">
            <FeeTable :vo="vo"></FeeTable>
        </div>
        <!-- <div v-else-if="activeTabName=='Family'">
            <FamilyTable :vo="vo" :can-edit="canEdit"></FamilyTable>
        </div> -->
        <div v-else-if="activeTabName == 'Hostel'">
            <DormitoryTable :vo="vo" :can-edit="canEdit">宿舍情况</DormitoryTable>
        </div>
        <div v-else-if="activeTabName == 'Exam'">
            <EexamTable :vo="vo"></EexamTable>
        </div>
        <div v-else-if="activeTabName == 'Grant'">
            <GrantTable :vo="vo" :can-edit="canEdit"></GrantTable>
        </div>
        <div v-else-if="activeTabName == 'Award'">
            <AwardTable :vo="vo"></AwardTable>
        </div>
        <div v-else-if="activeTabName == 'Violation'">
            <ViolationTable :vo="vo"></ViolationTable>
        </div>
        <div v-else-if="activeTabName == 'Leave'">
            <LeaveTable :vo="vo"></LeaveTable>
        </div>
        <div v-else-if="activeTabName == 'Graduate'">
            <GraduateTable :vo="vo"></GraduateTable>
        </div>

        <!-- <el-dialog v-if="dialogFormVisible" custom-class="box-dialog" fullscreen :visible.sync="dialogFormVisible" append-to-body="true" width="100%" height="650px" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="true" title="学籍卡">
            <div style="display:flex;justify-content:flex-end;padding:10px 0;">
                <el-button type="primary" @click="printContent">打印</el-button>
            </div>
            <div id="mainBox">
              <basicCard :vo="vo"></basicCard>
              <gradeCard :vo="vo"></gradeCard>
            </div>
        </el-dialog> -->
    </div>
    <!-- </el-dialog> -->
</template>

<script>
import Print from '@/wapp/common/utils/print.min.js'
import basicCard from './basicCard'
import gradeCard from './gradeCard'
import InfoView from './table/infoView'
import FeeTable from './table/feeTable'
import EexamTable from './table/examTable'
import AwardTable from './table/awardTable'
import ViolationTable from './table/violationTable'
import LeaveTable from './table/leaveTable'
import GraduateTable from './table/graduateTable'
import GrantTable from './table/grantTable'
import FamilyTable from './table/familyTable'
import DormitoryTable from './table/dormitoryTable'
import Record from './classRecord.vue'
export default {
    components: {
        InfoView,
        FeeTable,
        EexamTable,
        AwardTable,
        ViolationTable,
        LeaveTable,
        GraduateTable,
        GrantTable,
        FamilyTable,
        DormitoryTable,
        basicCard,
        gradeCard,
        Record
    },
    props: {
        vo: {},
        canEdit: {
            type: Number,
            default: 0
        }
    },
    data: function () {
        return {
            imageSrc: '',
            moduleInfo: {
                formTemplate: 'dcontent/busiformurl?vwtype=W&url=/student/basicInfo/formCard.html',
                addNewUrl: 'xsgl/studentBasicInfo/addNew',
                insertUrl: 'xsgl/studentBasicInfo/insert',
                getByIdUrl: 'xsgl/studentBasicInfo/getById',
                updateUrl: 'xsgl/studentBasicInfo/update',
                delUrl: 'xsgl/studentBasicInfo/delete',
                listDataUrl: 'xsgl/studentBasicInfo/listdata',
                winWidth: 1200,
                winHeight: 600,
                moduleCode: 'basicInfo',
                openViewType: '0',
                listAdvSearchAllFields: 0,
                listAdvSearchExpandPanel: 0,
                oldListDataUrl: '/xsgl/studentBasicInfo/listdata',
                busiFormTemplate: '/student/basicInfo/formCard'
            },
            dialogFormVisible: false,
            detail: {},
            // canEdit: 0,
            activeTabName: 'User',
            graduateData: [],
            feeData: [],
            leaveData: [],
            examData: [],
            awardData: [],
            violationData: [],
            grantData: [],
            familyData: [],
            avatarLoading: false,
            loginUser: this.$store.getters.loginUser,
            cardList: [] // 学籍卡数量
        }
    },
    computed: {},
    watch: {},
    created: function () {
        this.avatarLoading = true
        this.getStudentInfo()
    },
    beforeDestroy: function () {
        this.$bus.$off('showStudentFormDialog')
    },
    mounted: function () {
        console.log('表单信息', this.vo)

        let _this = this
        if (this.vo.hasPhoto) {
            _this.imageSrc = `${location.origin}${process.env.VUE_APP_BASE_API}/xsgl/studentBasicInfo/download?dataField=idPhoto&nameField=photoUrl&id=${this.vo.id}&httpPort=${location.port}`
        }
        this.avatarLoading = false
        _this.$bus.$on('showStudentFormDialog', (params) => {
            _this.type = params.type
            if (params) {
                _this.dialogFormVisible = true
            }
            if (params.type == 1) {
                _this.vo = { ...params.detail }
            }
        })

        this.$nextTick(() => {
            $('.main-box').parents('.el-table--border').addClass('main-box-border')
        })
    },
    methods: {
        printContent() {
            setTimeout(function () {
                Print({
                    printable: 'mainBox',
                    type: 'html',
                    scanStyles: false,
                    targetStyles: ['*'],
                    style: 'table {border-collapse: collapse; width: 100%;} th, td {border: 1px solid #0f0f0f;text-align:center}' // 可选-打印时去掉眉页眉尾
                })
            }, 500)
        },
        showCard(type = '') {
            console.log('type', type)
            var formId = this.vo ? this.vo.id : ''
            if (type === 1) {
                formId = this.cardList.filter((item) => item.educationLevel == '1')[0].id
            } else if (type === 2) {
                this.cardList.forEach((item) => {
                    console.log(itemt)
                })
                formId = this.cardList.filter((item) => item.educationLevel == '2')[0].id
            }
            window.open('#/newBusiForm?voId=' + formId + '&moduleInfo=' + encodeURIComponent(JSON.stringify(this.moduleInfo)) + '&title=学籍卡&canEdit=false&formUrl=student.basicInfo.formCard&noEdit=true')
        },
        changeTab: function (val) {
            this.activeTabName = val.name
        },
        avatarError(e) {
            if (e.type === 'error') {
                this.imageSrc = './images/w-imgs/default_avatar.png'
                // this.$set(this.vo, '', )
            }
        },
        filterEducationSystem(val) {
            if (val == 1) {
                return '二年'
            } else if (val == 2) {
                return '三年'
            } else if (val == 3) {
                return '四年'
            } else if (val == 4) {
                return '五年'
            } else if (val == 5) {
                return '六年'
            }
        },
        filterStatus(val) {
            if (val == 0) {
                return '在籍在校'
            } else if (val == 1) {
                return '在籍离校'
            } else if (val == 2) {
                return '未激活'
            } else if (val == 3) {
                return '已离校'
            } else if (val == 4) {
                return '在籍不在校'
            }
        },
        async getStudentInfo() {
            const data = [{ compare: '=', field: 'idCardNumber', merge: false, value: this.vo.idCardNumber }]
            const res = await this.$app.querydata('/xsgl/studentBasicInfo/querydata', data)
            if (res.code === 'success') {
                this.cardList = res.body.listdata
            } else {
                // this.$message.error(res.message)
            }
        }
    }
}
</script>
<style lang="scss">
#new-busi-form .main-box-border {
    border: none !important;
    &::before {
        background-color: transparent !important;
    }
    &::after {
        background-color: transparent !important;
    }
}
</style>
<style scoped lang="scss">
.el-dialog {
    border-radius: 0 !important;
}
.el-dialog .el-dialog__header {
    border-radius: 0 !important;
}
.main-box {
    // padding: 20px;
}

.info-box {
    padding-bottom: 20px;
    font-size: 14px;
    display: flex;
    line-height: 30px;
}
.header {
    padding: 10px 20px;
    background-color: #f2f5fb;
    font-size: 14px;
    font-weight: 500;
}
.el-tabs__header {
    width: 90% !important;
}
.el_dialog_footer {
    display: flex;
    justify-content: center;
    padding-top: 20px;
}
</style>
